<header class="page-header">
  <div class="filter-buttons">
    <button
      *ngIf="hasProfilePermission"
      class="filter-toggle-btn"
      [class.active]="cardsToApproveActive"
      (click)="toggleCardsToApprove()">
      <i class="icon-my-card"></i>
      {{ 'pages.userRecords.cardsToApprove' | translate }}
      <span class="badge" *ngIf="pendingCardsCount > 0">{{ pendingCardsCount }}</span>
    </button>
    <button
      *ngIf="hasFamilyPermission"
      class="filter-toggle-btn"
      [class.active]="familyLinksToApproveActive"
      (click)="toggleFamilyLinksToApprove()">
      <i class="icon-family"></i>
      {{ 'pages.userRecords.familyLinksToApprove' | translate }}
      <span class="badge" *ngIf="pendingFamilyLinksCount > 0">{{ pendingFamilyLinksCount }}</span>
    </button>
    <button
      *ngIf="hasProfilePermission"
      class="filter-toggle-btn"
      [class.active]="residencesToApproveActive"
      (click)="toggleResidencesToApprove()">
      <i class="icon-home"></i>
      {{ 'pages.userRecords.residencesToApprove' | translate }}
      <span class="badge" *ngIf="pendingResidencesCount > 0">{{ pendingResidencesCount }}</span>
    </button>
    <button class="more-filters-btn" (click)="openMoreFiltersModal()">
      <i class="icon-setting"></i>
      {{ 'pages.userRecords.moreFilters' | translate }}
    </button>
    <button class="reset-btn" (click)="resetFilters()">
      {{ 'pages.userRecords.reset' | translate }}
    </button>
  </div>
  <button routerLink="/user-create" class="bciti-button bciti-button--blue">
    {{ 'pages.userRecords.createUserButton' | translate }}
  </button>
</header>

<div class="search-filters">
  <form [formGroup]="advancedSearchForm" class="filters-row">
    <app-form-input 
      *ngIf="displayField(profileField.FIRSTNAME)" 
      [placeholder]="'common.fields.firstName' | translate"
      formControlName="firstName"
      data-cy="firstName">
    </app-form-input>
    <app-form-input 
      *ngIf="displayField(profileField.LASTNAME)" 
      [placeholder]="'common.fields.lastName' | translate"
      formControlName="lastName" 
      data-cy="lastName">
    </app-form-input>

    <app-form-datepicker
      [label]="'common.fields.birthdate' | translate"
      formControlName="birthDate"
      [showMessages]="false"
      data-cy="birthDate">
    </app-form-datepicker>
    <app-form-input 
      *ngIf="displayField(profileField.EMAIL)" 
      type="email" 
      [placeholder]="'common.fields.email' | translate"
      formControlName="email" 
      data-cy="email">
    </app-form-input>
    <app-form-input 
      *ngIf="displayField(profileField.PHONE)" 
      appPhoneMask 
      type="phone" 
      [placeholder]="'common.fields.mainPhone' | translate"
      formControlName="phone" 
      data-cy="phone">
    </app-form-input>
    <app-form-input 
      [placeholder]="'common.fields.cardCode' | translate"
      formControlName="cardCode" 
      data-cy="cardCode">
    </app-form-input>
  </form>
</div>

<div class="table-wrap">
  <app-user-table 
    #table 
    [columns]="userColumns" 
    [data]="users" 
    [length]="userLength"
    [pageIndex]="pageOptions?.pageIndex || 0" 
    [pageSize]="pageOptions?.itemsPerPage" 
    [exportData]="true"
    [maxExportResults]="maxExportResults"
    [isLoading]="tableReloading || loading"
    [residenceMap]="residenceMap"
    (page)="pageChange($event)"
    (export)="exportDataTable()"
    (approvalCompleted)="fetchPendingCounts()"
  ></app-user-table>
</div>